/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* CLEAR CART DRAWER  */
const clearBtn = document.querySelector('[data-clear-cart]');

function clearCart() {
    fetch('/cart/clear.js', {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({}),
    })
        .then((res) => { console.log(res), res.json() })
        .then(() => document.documentElement.dispatchEvent(new CustomEvent("cart:refresh")));
}


clearBtn.addEventListener('click', (event) => {
    event.preventDefault();
    clearCart()
});

// -------------------

/* CART TERMS AND CONDITIONS */
const termsOverlay = document.querySelector('.terms-overlay');
const termsContent = document.querySelector('.terms-content-wrapper');
const termsDeny = document.querySelector('.terms-deny');
const termsAccept = document.querySelector('.terms-accept');

function showTerms() {
    termsOverlay.classList.add('terms-overlay--active');
    termsContent.classList.add('terms-content-wrapper--active');
}

function hideTerms() {
    termsOverlay.classList.remove('terms-overlay--active');
    termsContent.classList.remove('terms-content-wrapper--active');
}
function validateTerms(e) {
    e.preventDefault();
    const cartTerms = document.querySelector('input[name=checkbox]');

    if (cartTerms.checked) {
        window.location = '/checkout';
    } else {
        showTerms();
    }
}

termsOverlay?.addEventListener('click', () => {
    hideTerms();
});

termsAccept?.addEventListener('click', () => {
    window.location = '/checkout';
});

termsDeny?.addEventListener('click', () => {
    hideTerms();
});

// -------------------

// GEO JS

const geoLinks = document.querySelectorAll(".geoLink");
const cookieOverlay = document.querySelector(".cookieOverlay");
const popup__Cookie = Cookies.get('countrySelector');
const geoPopup = document.querySelector(".geoPopup");


async function getIPLocation() {

    const config = {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
        },
    }
    const response = await fetch(`http://get.geojs.io/v1/ip/geo.json`, config)

        .then((res) => res.status === 200 ? res.json() : null)

        .then((data) => {
            const countryCode = data.country_code.toLowerCase();

            if (geoPopup) {
                if (popup__Cookie === undefined) {
                    geoPopup.style.display = "block";
                    cookieOverlay.style.display = "block";
                    geoPopup.classList.remove("hide");
                    cookieOverlay.classList.remove("hide");
                }

                if (popup__Cookie != undefined) {
                    geoPopup.classList.add("hide");
                    cookieOverlay.classList.add("hide");
                }

                if (window.location.href.includes("dk") && countryCode === 'dk') {
                    geoPopup.classList.add("hide");
                    cookieOverlay.classList.add("hide");
                }
            }
        })
        .catch(error => console.error(error))
}

getIPLocation();


geoLinks?.forEach(element => {
    element.addEventListener("click", () => {
        Cookies.set('countrySelector', element.href, { expires: 30 })
    })
});

/**
* ----------------------------------------------------------------------------
* Geo selector footer
* ----------------------------------------------------------------------------
*/

const geoSelector = document.querySelector(".geoSelector");
const geoOptions = document.querySelector(".geoSelector__list");

geoSelector?.addEventListener("click", () => {
    geoOptions.toggleAttribute('showlist');
})

//   const productItemImage = document.querySelectorAll(".ProductItem__Image");
//   const productItem = document.querySelectorAll(".ProductItem");

//   productItem?.forEach((item)=>{
//       if(item.outerText.includes("DISORDER")){
//         item.parentElement.classList.add("hide");
//         item.classList.add("hide");
//       }
//   })

